import { addMethod, string, type StringSchema } from 'yup';

export const STRING_FIELD_MAX = {
   dbVarchar: 255,
   phone: 45,
   iban: 34,
   vatId: 50,
} as const;

declare module 'yup' {
   interface StringSchema<
      TType extends import('yup').Maybe<string> = string | undefined,
      TContext = import('yup').AnyObject,
      TDefault = undefined,
      TFlags extends import('yup').Flags = '',
   > {
      maxDbVarchar(): StringSchema<TType, TContext, TDefault, TFlags>;
      maxPhoneField(): StringSchema<TType, TContext, TDefault, TFlags>;
      maxIban(): StringSchema<TType, TContext, TDefault, TFlags>;
      maxVatId(): StringSchema<TType, TContext, TDefault, TFlags>;

      nullableWithMax(): StringSchema<TType | null, TContext, TDefault, TFlags>;
      requiredWithMax(): StringSchema<NonNullable<TType>, TContext, TDefault, TFlags>;
      nullableWithPhoneMax(): StringSchema<TType | null, TContext, TDefault, TFlags>;
      requiredWithPhoneMax(): StringSchema<NonNullable<TType>, TContext, TDefault, TFlags>;
      nullableWithIbanMax(): StringSchema<TType | null, TContext, TDefault, TFlags>;
      requiredWithIbanMax(): StringSchema<NonNullable<TType>, TContext, TDefault, TFlags>;
      nullableWithVatIdMax(): StringSchema<TType | null, TContext, TDefault, TFlags>;
      requiredWithVatIdMax(): StringSchema<NonNullable<TType>, TContext, TDefault, TFlags>;
   }
}

let registered = false;

function registerStringLengthMethods(): void {
   if (registered) {
      return;
   }
   registered = true;

   addMethod<StringSchema>(string, 'maxDbVarchar', function maxDbVarchar(this: StringSchema) {
      return this.max(STRING_FIELD_MAX.dbVarchar);
   });
   addMethod<StringSchema>(string, 'maxPhoneField', function maxPhoneField(this: StringSchema) {
      return this.max(STRING_FIELD_MAX.phone);
   });
   addMethod<StringSchema>(string, 'maxIban', function maxIban(this: StringSchema) {
      return this.max(STRING_FIELD_MAX.iban);
   });
   addMethod<StringSchema>(string, 'maxVatId', function maxVatId(this: StringSchema) {
      return this.max(STRING_FIELD_MAX.vatId);
   });

   addMethod<StringSchema>(string, 'nullableWithMax', function nullableWithMax(this: StringSchema) {
      return this.nullable().max(STRING_FIELD_MAX.dbVarchar) as StringSchema;
   });
   addMethod<StringSchema>(string, 'requiredWithMax', function requiredWithMax(this: StringSchema) {
      return this.required().max(STRING_FIELD_MAX.dbVarchar);
   });
   addMethod<StringSchema>(string, 'nullableWithPhoneMax', function nullableWithPhoneMax(this: StringSchema) {
      return this.nullable().max(STRING_FIELD_MAX.phone) as StringSchema;
   });
   addMethod<StringSchema>(string, 'requiredWithPhoneMax', function requiredWithPhoneMax(this: StringSchema) {
      return this.required().max(STRING_FIELD_MAX.phone);
   });
   addMethod<StringSchema>(string, 'nullableWithIbanMax', function nullableWithIbanMax(this: StringSchema) {
      return this.nullable().max(STRING_FIELD_MAX.iban) as StringSchema;
   });
   addMethod<StringSchema>(string, 'requiredWithIbanMax', function requiredWithIbanMax(this: StringSchema) {
      return this.required().max(STRING_FIELD_MAX.iban);
   });
   addMethod<StringSchema>(string, 'nullableWithVatIdMax', function nullableWithVatIdMax(this: StringSchema) {
      return this.nullable().max(STRING_FIELD_MAX.vatId) as StringSchema;
   });
   addMethod<StringSchema>(string, 'requiredWithVatIdMax', function requiredWithVatIdMax(this: StringSchema) {
      return this.required().max(STRING_FIELD_MAX.vatId);
   });
}

registerStringLengthMethods();
